export enum SearchSuggestionToggleEnum {
    SHOWN = 'shown',
    HIDDEN = 'hidden',
}

export interface SearchSuggestionToggle {
    status: SearchSuggestionToggleEnum;
}

export function createHeaderSearchDataLayerEvent(
    suggestionToggle: SearchSuggestionToggle,
): CustomEvent {
    return new CustomEvent('onHeaderSearchSuggestionFlyoutToggle', {
        detail: suggestionToggle,
    });
}

export function dispatchSearchSuggestionStatusEvent(
    suggestionToggle: SearchSuggestionToggle,
): void {
    const event = createHeaderSearchDataLayerEvent(suggestionToggle);
    window.dispatchEvent(event);
}
